/** @module AQL/Defect/FIDefectForm */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/_base/underscore",
	"csi",
	"csi/def/Action",
	"csi/def/Relationship",
	"csi/def/ViewRef",
	"csi/def/Field",
	"csi/form/Widget",
	"csi/locale",
	"csi/store/_base",
	"csi/store/Names",
	"csi/xml",
	"csi/xml/Query"
], function(declare, lang, _, csi, Action, Relationship, ViewRef, Field, FormWidget, locale, csiStore, Names, xml, Query) {

	const _Colorways = declare(Names, {
		/**
		 * C8-33634: concatenate Style name to colorways
		 * @param {Node} node
		 * @param {Cache} cache
		 * @return {Node}
		*/
		_processResultNode: function(node, cache) {
			const style = cache.getNode(node.__Parent__);
			const item = {$: xml.nodeGetURL(node), Name: locale.getNodeConfiguredName(node, cache) + " " + locale.getNodeConfiguredName(style, cache), node: node};
			return item;
		}
	});

	return declare(FormWidget, {

		FIELD_ASSORTMENT_STYLE: "AssortmentStyle",
		FIELD_BATCH_ERROR_TYPE: "BatchErrorType",
		FIELD_COLORWAYS: "Colorways",
		FIELD_DEFECT: "Defect",
		FIELD_SIZES: "Sizes",
		FIELD_SKUS: "SKUs",
		FIELD_PART_MATERIALS: "FIPartMaterials",

		/** @property {boolean} bSamplingPlanOnSections - flag that indicates that the sampling plan is added to sections and defects can be added to sections */
		bSamplingPlanOnSections: false,

		/**
		 * Figure out the batch node
		 * For defect on test set default Colorway, Size or SKU values
		 * Set onChange functions
		*/
		_resolveView: function() {
			const sourceNode = this.getSourceController().getParent();
			switch (xml.nodeGetType(sourceNode)) {
				case "FinalInspectionBatch":
					this.batch = sourceNode;
					const defect = this.getSourceController().getNode(); // if editing a defect
					if (defect && defect.Sections && defect.Sections.length > 0) {
						sectionURL = defect.Sections[0];
						this.section = this.getCache().getNode(sectionURL);
						this.bSamplingPlanOnSections = true;
					}
					break;
				case "FinalInspectionBatchSection":
					this.section = sourceNode;
					if (xml.isValidURL(this.section.SamplingPlan)) {
						this.bSamplingPlanOnSections = true;
					}
					this.batch = this.getCache().getNode(sourceNode.__Parent__);
					break;
				case "FinalInspectionBatchTest":
					this.section = this.getCache().getNode(sourceNode.__Parent__);
					if (xml.isValidURL(this.section.SamplingPlan)) {
						this.bSamplingPlanOnSections = true;
					}
					this.batch = this.getCache().getNode(this.section.__Parent__);
					if (xml.isValidURL(sourceNode.Colorway)) {
						this.addDefaultValue(this.FIELD_COLORWAYS, sourceNode.Colorway);
					}
					if (xml.isValidURL(sourceNode.FIPartMaterial)) {
						this.addDefaultValue(this.FIELD_PART_MATERIALS, sourceNode.FIPartMaterial);
					}
					break;
				default:
					this.batch = sourceNode;
			}

			// if inspection has Assortment Styles, add AssortmentStyles field if defect is added on batch (field is not required) or if section is assortment dependent (field is required)
			const self = this;
			if (this.section) {
				if (this.section.IsAssortmentDependent) {
					this.defView.addFieldAfter(lang.mixin(new Field(), {
						m_id: self.FIELD_ASSORTMENT_STYLE,
						m_onChange: "onChangeAssortmentStyle"
					}), "Defect");
					if (xml.isValidURL(this.section.AssortmentStyle)) {
						this.addDefaultValue(this.FIELD_ASSORTMENT_STYLE, this.section.AssortmentStyle);
					}
				}
			} else {
				if (this.batch && this.batch.__Parent__) {
					const inspection = this.getCache().getNode(this.batch.__Parent__);
					if (inspection.AssortmentStyles && inspection.AssortmentStyles.length > 0) {
						this.defView.addFieldAfter(lang.mixin(new Field(), {
							m_id: self.FIELD_ASSORTMENT_STYLE,
							m_onChange: "onChangeAssortmentStyle"
						}), "Defect");
					}
				}
			}

			this.inherited(arguments);

			const {defView} = this;

			const fieldDefect = defView.getField(this.FIELD_DEFECT);
			if (fieldDefect) {
				fieldDefect.m_onChange = "onChangeDefect";
			}

			const fieldColorways = defView.getField(this.FIELD_COLORWAYS);
			if (fieldColorways) {
				fieldColorways.m_onChange = "onChangeColorwaysOrSizes";
			}

			const fieldSizes = defView.getField(this.FIELD_SIZES);
			if (fieldSizes) {
				fieldSizes.m_onChange = "onChangeColorwaysOrSizes";
			}

			const fieldSkus = defView.getField(this.FIELD_SKUS);
			if (fieldSkus) {
				fieldSkus.m_onChange = "onChangeSKUs";
			}
		},

		/**
		 * Modified the store to use batch url, whether the form is called on batch, section or test
		 * @param {Field} field- field on the form
		 * @param {string} value - value of the field
		 * @return {Store} - the store for field
		 */
		getFieldStore: function(field, value) {
			field = this.getField(field);
			const fieldCtrlName = field.getControlName();
			if (![this.FIELD_ASSORTMENT_STYLE,
			this.FIELD_BATCH_ERROR_TYPE,
			this.FIELD_COLORWAYS,
			this.FIELD_DEFECT,
			this.FIELD_SIZES,
			this.FIELD_SKUS,
			this.FIELD_PART_MATERIALS
			].includes(fieldCtrlName)) {
				return this.inherited(arguments);
			}

			const storeOptions = {data: [csiStore.nameObject("")]};

			if (this.FIELD_DEFECT == fieldCtrlName) {
				let node = this.batch;
				if (this.bSamplingPlanOnSections) {
					node = this.section;
				}
				const q = new Query()
					.Attr("Active", xml.OP_EQUALS, true);
				let i = 0;
				_.each(node.AvailableDefectErrorTypes, function(errorType) {
					if (!i) {
						this.RefAttr("DefaultErrorType", xml.OP_NULL);
						this.RefAttr("DefaultErrorType", xml.OP_EQUALS, csi.EMPTY_URL);
						i = 1;
					}
					this.RefAttr("DefaultErrorType", xml.OP_EQUALS, errorType);
				}, q.Or());

				const rel = lang.mixin(new Relationship(), {
					m_typeNode: "Defect",
					m_query: q
				});

				csiStore.namesOptionsByRelationship(this.getContext(), rel, storeOptions);

				storeOptions.action = lang.mixin(new Action(), {
					m_viewRef: lang.mixin(new ViewRef(), {
						m_id: field.heading.m_action.m_viewRef.m_id,
						m_url: field.heading.m_action.m_viewRef.m_url
					}),
					m_fixedQuery: q,
				});

			} else {

				let url = this.batch.$URL;
				if (fieldCtrlName == this.FIELD_BATCH_ERROR_TYPE) {
					// if RecommendedResult is on Sections => Sampling Plan and Error Types are on Sections too
					// get the error types from sections
					if (this.batch && this.bSamplingPlanOnSections && this.section) {
						url = xml.nodeGetURL(this.section);
					}
				}

				const assortmentStyleURL = this.getFieldValue(this.FIELD_ASSORTMENT_STYLE);
				const cache = this.getCache();
				const inspection = cache.getNode(this.batch.__Parent__);
				const styleURL = (xml.isValidURL(assortmentStyleURL)) ? assortmentStyleURL : inspection.Style;
				const filter = new Query();
				switch (fieldCtrlName) {
					case this.FIELD_ASSORTMENT_STYLE:
						if (this.section && this.section.IsAssortmentDependent) {
							filter.Node(xml.PROP_URL, xml.OP_EQUALS, this.section.AssortmentStyle);
						}
						break;
					case this.FIELD_SIZES:
						const style = cache.getNode(styleURL);
						if (style && !_.isEmpty(style.ProductSizes)) {
							_.each(style.ProductSizes, function(productSize) {
								this.Node(xml.PROP_URL, xml.OP_EQUALS, productSize);
							}, filter.Or());
						}
						break;
					case this.FIELD_PART_MATERIALS:
						filter.RefAttr("Style", xml.OP_EQUALS, styleURL, "Child:__Parent__");
						break;
					case this.FIELD_COLORWAYS:
					case this.FIELD_SKUS:
						filter.RefAttr(xml.ATTR_PARENT, xml.OP_EQUALS, styleURL);
						break;
					default:
						break;
				}

				const rel = lang.mixin(new Relationship(), {
					m_url: url,
					m_addPaths: field.heading.m_relationship.m_addPaths,
					m_query: filter,
					m_sorts: fieldCtrlName === this.FIELD_SIZES ? [{id: "SizeCode"}] : null
				});

				csiStore.namesOptionsByRelationship(this.getContext(), rel, storeOptions);

				storeOptions.action = lang.mixin(new Action(), {
					m_viewRef: lang.mixin(new ViewRef(), {
						m_id: field.heading.m_action.m_viewRef.m_id,
						m_url: url
					}),
					m_fixedQuery: filter
				});
			}
			storeOptions.customOperation = true;
			return fieldCtrlName == this.FIELD_COLORWAYS ? new _Colorways(storeOptions) : new Names(storeOptions);
		},

		/**
		 * If Defect is selected => set error type to Defect.DefaultErrorType if exists
		 * @param {View} defView - view definition
		 * @param {Field} field- field on the form (Colorways or Sizes)
		 * @param {Array} value- value of Colorways or Sizes field
		*/
		onChangeDefect: function(defView, field, value) {
			if (!value) {
				return;
			}

			const cache = defView.m_formData.getCache();
			let node = this.batch;
			if (this.bSamplingPlanOnSections) {
				node = this.section;
			}
			const defectNode = cache.getNode(this.getFieldValue(this.FIELD_DEFECT));
			if (defectNode && xml.isValidURL(defectNode.DefaultErrorType)) {
				const defectErrorType = _.filter(node.ErrorTypes, function(errorType) {
					const errorTypeNode = cache.getNode(errorType);
					if (errorTypeNode.ErrorType && errorTypeNode.ErrorType == defectNode.DefaultErrorType) {
						return true;
					}
				});

				if (defectErrorType && defectErrorType.length) {
					this.setFieldValue(this.FIELD_BATCH_ERROR_TYPE, defectErrorType[0]);
				}
			}
		},

		/**
		 * If AssortmentStyles are selected, adjust Colorways, Sizes and SKUs acccordingly
		 * @param {View} defView - view definition
		 * @param {Field} field- field on the form (Colorways or Sizes)
		 * @param {Array} value- value of Colorways or Sizes field
		*/
		onChangeAssortmentStyle: function(defView, field, value) {

			// reset selections
			this.setFieldValue(this.FIELD_COLORWAYS, []);
			this.setFieldValue(this.FIELD_SKUS, []);
			this.setFieldValue(this.FIELD_SIZES, []);
			this.setFieldValue(this.FIELD_PART_MATERIALS, []);

			this.setFieldStore(this.FIELD_COLORWAYS, this.getFieldStore(this.FIELD_COLORWAYS));
			this.setFieldStore(this.FIELD_SKUS, this.getFieldStore(this.FIELD_SKUS));
			this.setFieldStore(this.FIELD_SIZES, this.getFieldStore(this.FIELD_SIZES));
			this.setFieldStore(this.FIELD_PART_MATERIALS, this.getFieldStore(this.FIELD_PART_MATERIALS));
		},

		/**
		 * If Colorways or Sizes are selected => remove skus that do not have that colorway or size
		 * @param {View} defView - view definition
		 * @param {Field} field- field on the form (Colorways or Sizes)
		 * @param {Array} value- value of Colorways or Sizes field
		*/
		onChangeColorwaysOrSizes: function(defView, field, value) {
			const cache = defView.m_formData.getCache();
			const skus = this.getFieldValue(this.FIELD_SKUS);
			const skuAttr = (field.m_id === this.FIELD_COLORWAYS ? "RealizedColor" : "RealizedSize");
			const new_skus = _.filter(skus, function(sku) {
				if (!sku) {
					return false;
				}
				const skuNode = cache.getNode(sku);
				if (!skuNode) {
					return false;
				}
				const skuValue = skuNode[skuAttr];
				return skuValue && value && value.includes(skuValue);
			});
			if (new_skus.length != skus.length) {
				this.setFieldValue(this.FIELD_SKUS, new_skus);
			}
		},

		/**
		 * If SKUs are selected => add colorways and sizes of that sku
		 * @param {View} defView - view definition
		 * @param {Field} field- field on the form (SKUs)
		 * @param {Array} value- value of SKUs field
		*/
		onChangeSKUs: function(defView, field, value) {
			if (value && value.length > 0) {
				const cache = defView.m_formData.getCache();
				const colorways = this.getFieldValue(this.FIELD_COLORWAYS) || [];
				const sizes = this.getFieldValue(this.FIELD_SIZES) || [];
				let changeColorways = false;
				let changeSizes = false;
				_.each(value, function(s) {
					const sku = cache.getNode(s);
					if (sku) {
						if (!colorways.includes(sku.RealizedColor)) {
							changeColorways = true;
							colorways.push(sku.RealizedColor);
						}
						if (!sizes.includes(sku.RealizedSize)) {
							changeSizes = true;
							sizes.push(sku.RealizedSize);
						}
					}
				});
				if (changeColorways) {
					this.setFieldValue(this.FIELD_COLORWAYS, colorways);
				}
				if (changeSizes) {
					this.setFieldValue(this.FIELD_SIZES, sizes);
				}
			}
		}

	});
});